var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoamIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 130,
    viewBox: "0 0 142 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.899 70.1583C130.425 61.6216 119.843 65.5752 104.855 55.9566C97.3885 51.1438 90.9161 44.3912 88.5002 41.8743C83.335 36.498 76.7776 44.5596 76.7776 44.5596C76.7776 44.5596 57.6143 68.5218 57.5797 84.963C57.514 107.433 67.7221 114.605 71.6922 116.472C75.6623 118.339 93.3848 120.62 106.196 109.159C125.295 92.042 129.719 73.0566 129.899 70.1583ZM80.3929 65.0847C82.6152 62.9754 87.7228 63.1145 90.5853 65.4431C94.8295 68.8884 92.1189 72.874 89.9929 73.144C87.4261 73.4715 85.3657 72.5801 81.7129 69.904C80.3561 68.907 78.7872 66.6079 80.3929 65.0847ZM89.1228 105.374C89.1006 105.429 89.0627 105.477 89.0138 105.511C88.9648 105.545 88.907 105.563 88.8475 105.565C88.788 105.566 88.7293 105.55 88.6788 105.519C88.6284 105.487 88.5882 105.441 88.5635 105.387C87.8649 103.863 85.6352 99.9214 80.1714 96.6573C74.8472 93.4562 70.6088 93.1469 68.9379 93.1741C68.8767 93.1746 68.8167 93.1566 68.7658 93.1225C68.715 93.0884 68.6756 93.0397 68.6528 92.9829C68.63 92.9261 68.6249 92.8637 68.6381 92.8039C68.6513 92.7441 68.6823 92.6897 68.7269 92.6478C70.5402 90.9197 76.5931 86.1832 84.3187 91.064C92.119 95.9658 90.0046 103.184 89.1228 105.374ZM104.141 84.1431C100.119 82.0632 98.404 80.6132 97.5538 78.171C96.8581 76.1587 99.2103 71.9462 104.187 74.212C107.547 75.7415 109.944 80.2522 109.045 83.1818C108.394 85.3014 105.623 84.9209 104.141 84.1431Z",
    fill: "#C47AFF",
    fillOpacity: 0.59
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.899 70.1583C130.425 61.6216 119.843 65.5752 104.855 55.9566C97.3885 51.1438 90.9161 44.3912 88.5002 41.8743C83.335 36.498 76.7776 44.5596 76.7776 44.5596C76.7776 44.5596 57.6143 68.5218 57.5797 84.963C57.514 107.433 67.7221 114.605 71.6922 116.472C75.6623 118.339 93.3848 120.62 106.196 109.159C125.295 92.042 129.719 73.0566 129.899 70.1583ZM80.3929 65.0847C82.6152 62.9754 87.7228 63.1145 90.5853 65.4431C94.8295 68.8884 92.1189 72.874 89.9929 73.144C87.4261 73.4715 85.3657 72.5801 81.7129 69.904C80.3561 68.907 78.7872 66.6079 80.3929 65.0847ZM89.1228 105.374C89.1006 105.429 89.0627 105.477 89.0138 105.511C88.9648 105.545 88.907 105.563 88.8475 105.565C88.788 105.566 88.7293 105.55 88.6788 105.519C88.6284 105.487 88.5882 105.441 88.5635 105.387C87.8649 103.863 85.6352 99.9214 80.1714 96.6573C74.8472 93.4562 70.6088 93.1469 68.9379 93.1741C68.8767 93.1746 68.8167 93.1566 68.7658 93.1225C68.715 93.0884 68.6756 93.0397 68.6528 92.9829C68.63 92.9261 68.6249 92.8637 68.6381 92.8039C68.6513 92.7441 68.6823 92.6897 68.7269 92.6478C70.5402 90.9197 76.5931 86.1832 84.3187 91.064C92.119 95.9658 90.0046 103.184 89.1228 105.374ZM104.141 84.1431C100.119 82.0632 98.404 80.6132 97.5538 78.171C96.8581 76.1587 99.2103 71.9462 104.187 74.212C107.547 75.7415 109.944 80.2522 109.045 83.1818C108.394 85.3014 105.623 84.9209 104.141 84.1431Z",
    fill: "url(#paint0_linear_510_2832)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_510_2832",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 40,
    width: 73,
    height: 79
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.899 70.1583C130.425 61.6216 119.843 65.5752 104.855 55.9566C97.3885 51.1438 90.9161 44.3912 88.5002 41.8743C83.335 36.4981 76.7776 44.5596 76.7776 44.5596C76.7776 44.5596 57.6143 68.5218 57.5797 84.963C57.514 107.433 67.7221 114.605 71.6922 116.472C75.6623 118.339 93.3848 120.62 106.196 109.159C125.295 92.042 129.719 73.0566 129.899 70.1583ZM80.3929 65.0847C82.6152 62.9754 87.7228 63.1145 90.5853 65.4431C94.8295 68.8884 92.1189 72.874 89.9929 73.1441C87.4261 73.4715 85.3657 72.5802 81.7129 69.9041C80.3561 68.907 78.7872 66.6079 80.3929 65.0847ZM89.1228 105.374C89.1006 105.429 89.0627 105.477 89.0138 105.511C88.9648 105.545 88.907 105.563 88.8475 105.565C88.788 105.566 88.7293 105.55 88.6788 105.519C88.6284 105.487 88.5882 105.441 88.5635 105.387C87.8649 103.863 85.6352 99.9214 80.1714 96.6573C74.8472 93.4562 70.6088 93.1469 68.9379 93.1741C68.8767 93.1746 68.8167 93.1566 68.7658 93.1225C68.715 93.0884 68.6756 93.0398 68.6528 92.9829C68.63 92.9261 68.6249 92.8637 68.6381 92.8039C68.6513 92.7441 68.6823 92.6897 68.7269 92.6478C70.5402 90.9198 76.5931 86.1832 84.3187 91.064C92.119 95.9658 90.0046 103.184 89.1228 105.374ZM104.141 84.1432C100.119 82.0632 98.404 80.6132 97.5538 78.1711C96.8581 76.1587 99.2103 71.9463 104.187 74.212C107.547 75.7415 109.944 80.2522 109.045 83.1819C108.394 85.3015 105.623 84.9209 104.141 84.1432Z",
    fill: "url(#paint1_linear_510_2832)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_510_2832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.5 116C107.5 121.5 126 69 120.5 56L142.5 64.5001L127 92.5L102.5 123L71.5 123L68.5 116Z",
    fill: "url(#paint2_linear_510_2832)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5 77C84.1916 68.1678 89.6667 51.3334 90.5 40.5C91.8333 41.3334 92.7 39.8 89.5 35C85.5 29 63 36.5 53 44C45 50 41.3333 74 43 88C46.3333 86.8334 61.9999 86.5 73.5 77Z",
    fill: "black",
    fillOpacity: 0.1
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4736 19.6107C80.5755 11.5633 72.4233 19.3779 54.8549 16.4772C46.0929 15.028 37.4732 11.3712 34.2616 10.0164C27.3931 7.1244 24.545 17.1231 24.545 17.1231C24.545 17.1231 16.4458 46.7101 22.9035 61.8259C31.7334 82.4853 43.9486 85.0351 48.3305 85.1794C52.7125 85.3236 69.8976 80.4057 77.1254 64.804C87.9103 41.5219 84.4558 22.3366 83.4736 19.6107ZM33.9612 34.3812C36.248 32.0995 41.6831 32.0361 44.817 34.3463C49.454 37.752 46.7134 41.9904 44.4758 42.3543C41.7605 42.7969 39.5362 41.9554 35.5496 39.3229C34.0659 38.3454 32.3142 36.0238 33.9612 34.3812ZM48.0556 71.438C37.4788 70.558 35.1045 62.3169 34.5778 59.2156C34.5642 59.1357 34.5757 59.0535 34.6109 58.9805C34.646 58.9075 34.703 58.8472 34.7739 58.8081C34.8449 58.7689 34.9262 58.7527 35.0067 58.7618C35.0873 58.7709 35.1629 58.8049 35.2233 58.8589C36.7807 60.2643 40.8432 63.0268 49.0838 63.8078C56.8244 64.5396 60.7159 63.4221 62.3717 62.6722C62.458 62.6334 62.554 62.6213 62.6473 62.6375C62.7406 62.6537 62.8269 62.6975 62.895 62.7633C62.9632 62.829 63.0101 62.9136 63.0297 63.0062C63.0493 63.0989 63.0407 63.1952 63.005 63.2829C61.9317 65.9938 58.3287 72.2869 48.0556 71.438ZM68.4403 43.431C63.9147 44.954 61.5387 45.195 59.0362 44.0741C56.9681 43.1501 55.4012 38.3479 60.7616 36.2455C64.3791 34.8258 69.618 36.2741 71.2412 39.0612C72.4155 41.0675 70.1244 42.8651 68.4403 43.431Z",
    fill: "url(#paint3_linear_510_2832)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_510_2832",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 9,
    width: 65,
    height: 77
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4736 19.6107C80.5755 11.5633 72.4233 19.3779 54.8549 16.4772C46.0929 15.028 37.4732 11.3712 34.2616 10.0164C27.3931 7.1244 24.545 17.1231 24.545 17.1231C24.545 17.1231 16.4458 46.7101 22.9035 61.8259C31.7334 82.4853 43.9486 85.0351 48.3305 85.1794C52.7125 85.3236 69.8976 80.4057 77.1254 64.804C87.9103 41.5219 84.4558 22.3366 83.4736 19.6107ZM33.9612 34.3812C36.248 32.0995 41.6831 32.0361 44.817 34.3463C49.454 37.752 46.7134 41.9904 44.4758 42.3543C41.7605 42.7969 39.5362 41.9554 35.5496 39.3229C34.0659 38.3454 32.3142 36.0238 33.9612 34.3812ZM48.0556 71.438C37.4788 70.558 35.1045 62.3169 34.5778 59.2156C34.5642 59.1357 34.5757 59.0535 34.6109 58.9805C34.646 58.9075 34.703 58.8472 34.7739 58.8081C34.8449 58.7689 34.9262 58.7527 35.0067 58.7618C35.0873 58.7709 35.1629 58.8049 35.2233 58.8589C36.7807 60.2643 40.8432 63.0268 49.0838 63.8078C56.8244 64.5396 60.7159 63.4221 62.3717 62.6722C62.458 62.6334 62.5541 62.6213 62.6473 62.6375C62.7406 62.6537 62.8269 62.6975 62.895 62.7633C62.9632 62.829 63.0101 62.9136 63.0297 63.0062C63.0493 63.0989 63.0407 63.1952 63.005 63.2829C61.9317 65.9938 58.3287 72.2869 48.0556 71.438ZM68.4403 43.431C63.9147 44.954 61.5387 45.195 59.0362 44.0741C56.9681 43.1501 55.4012 38.3479 60.7616 36.2455C64.3791 34.8258 69.618 36.2741 71.2412 39.0612C72.4155 41.0675 70.1244 42.8651 68.4403 43.431Z",
    fill: "url(#paint4_linear_510_2832)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4736 19.6107C80.5755 11.5633 72.4233 19.3779 54.8549 16.4772C46.0929 15.028 37.4732 11.3712 34.2616 10.0164C27.3931 7.1244 24.545 17.1231 24.545 17.1231C24.545 17.1231 16.4458 46.7101 22.9035 61.8259C31.7334 82.4853 43.9486 85.0351 48.3305 85.1794C52.7125 85.3236 69.8976 80.4057 77.1254 64.804C87.9103 41.5219 84.4558 22.3366 83.4736 19.6107ZM33.9612 34.3812C36.248 32.0995 41.6831 32.0361 44.817 34.3463C49.454 37.752 46.7134 41.9904 44.4758 42.3543C41.7605 42.7969 39.5362 41.9554 35.5496 39.3229C34.0659 38.3454 32.3142 36.0238 33.9612 34.3812ZM48.0556 71.438C37.4788 70.558 35.1045 62.3169 34.5778 59.2156C34.5642 59.1357 34.5757 59.0535 34.6109 58.9805C34.646 58.9075 34.703 58.8472 34.7739 58.8081C34.8449 58.7689 34.9262 58.7527 35.0067 58.7618C35.0873 58.7709 35.1629 58.8049 35.2233 58.8589C36.7807 60.2643 40.8432 63.0268 49.0838 63.8078C56.8244 64.5396 60.7159 63.4221 62.3717 62.6722C62.458 62.6334 62.5541 62.6213 62.6473 62.6375C62.7406 62.6537 62.8269 62.6975 62.895 62.7633C62.9632 62.829 63.0101 62.9136 63.0297 63.0062C63.0493 63.0989 63.0407 63.1952 63.005 63.2829C61.9317 65.9938 58.3287 72.2869 48.0556 71.438ZM68.4403 43.431C63.9147 44.954 61.5387 45.195 59.0362 44.0741C56.9681 43.1501 55.4012 38.3479 60.7616 36.2455C64.3791 34.8258 69.618 36.2741 71.2412 39.0612C72.4155 41.0675 70.1244 42.8651 68.4403 43.431Z",
    fill: "url(#paint5_linear_510_2832)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_510_2832)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M70.4998 87.5L47.9997 86C75.5017 75.6305 85.5226 35.9907 77.6962 19.5C75.1307 20.1667 67.5997 21.4 57.9997 21C45.9997 20.5 27.9997 15 26.4997 9.00001C25.2997 4.20001 32.6664 5.00001 36.4997 6.00001L71.4997 13L74.4997 15L79.4998 10.5L96.4998 10.5L91.9998 47L70.4998 87.5Z",
    fill: "url(#paint6_linear_510_2832)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5 86C18.1 72 20.8333 31.5 26 13L15 25C12.8333 34 8.3 52.5 7.5 54.5C6.7 56.5 6.5 82.6667 6.5 95.5C33.1667 98.1667 78.9 100 48.5 86Z",
    fill: "url(#paint7_linear_510_2832)",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_510_2832",
    x1: 139.5,
    y1: 84.5,
    x2: 49.5,
    y2: 89.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F2CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_510_2832",
    x1: 152.5,
    y1: 59,
    x2: 37,
    y2: 110,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AD381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_510_2832",
    x1: 130.5,
    y1: 63.5,
    x2: 66.5,
    y2: 127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_510_2832",
    x1: 14.4995,
    y1: 43,
    x2: 87.9995,
    y2: 53.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_510_2832",
    x1: 8.99951,
    y1: 42,
    x2: 91.9995,
    y2: 50.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A4A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_510_2832",
    x1: 84.9996,
    y1: 43.5,
    x2: 37.8361,
    y2: 82.4761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD85E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD85E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_510_2832",
    x1: 68.4997,
    y1: 24,
    x2: 72.2497,
    y2: 87.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_510_2832",
    x1: 32.5271,
    y1: 13,
    x2: 32.5271,
    y2: 97.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoamIcon);
export default __webpack_public_path__ + "static/media/RoamIcon.3055b47c5ed1c9e7753c6477311d7a5e.svg";
export { ForwardRef as ReactComponent };